import { getToken } from "@ctsu/loader";

async function sendFileUploadRequest(url, method, formData, auth) {
  const token = getToken();

  const headers = new Headers();
  if (auth && token) {
    headers.append("Authorization", `Bearer ${token}`);
  } else if (process.env.REACT_APP_NAME) {
    headers.append("appName", process.env.REACT_APP_NAME);
  }

  const options = {
    method: method.toUpperCase(),
    body: formData,
    headers
  };

  const response = await fetch(url, options);

  if (!response.ok) {

    let errorData;
    const contentType = response?.headers?.get("content-type");

    try {
      if (contentType && contentType.includes("application/json")) {
        errorData = await response.json();
      } else {
        errorData = await response.text();
      }
    } catch (parseError) {
      errorData = `HTTP ${response.status}: ${response.statusText}`;
    }

    // Create error object with all the details
    const error = new Error(
      errorData?.message ||
      errorData?.error ||
      (typeof errorData === 'string' ? errorData : `HTTP ${response.status}`)
    );

    error.response = {
      status: response.status,
      statusText: response.statusText,
      data: errorData
    };

    throw error;
  }

  // Parse successful response
  const contentType = response?.headers?.get("content-type");
  if (contentType && contentType.includes("application/json")) {
    return response.json();
  }

  return response;
}
async function downloadFile(url, auth = true) {
  const token = getToken();

  const headers = new Headers();
  if (auth && token) {
    headers.append("Authorization", `Bearer ${token}`);
  } else if (process.env.REACT_APP_NAME) {
    headers.append("appName", process.env.REACT_APP_NAME);
  }

  const response = await fetch(url, { headers });
  const {status} = response;

  if (status === 200) {
    const contentType = response.headers.get("Content-Type");

    if (contentType === "application/octet-stream") {
      const fileName = response.headers.get("content-disposition");
      const blobResponse = await response.blob();
      return { blobResponse, fileName };
    }
    const textResponse = await response.text();
    let jsonResponse;
    try {
      jsonResponse = JSON.parse(textResponse);
    } catch (error) {
      jsonResponse = textResponse;
    }
    return jsonResponse;
  }
  return Promise.reject(new Error(`Failed to download file. HTTP status: ${status}`));
}



const makeFileUploadRequest = (url, formData, method = "PUT", auth = true) => {
  return sendFileUploadRequest(url, method, formData, auth);
};

export default makeFileUploadRequest;
export { downloadFile};
